module.exports = __webpack_public_path__ + "static/img/deportes_08.224e027a.jpeg";